import { useSelector } from 'react-redux';
import {
  Navigate,
  Outlet
} from 'react-router-dom';
import * as URLS from '@src/constants/URLS.const';
import { UserState } from '@src/store/user/user.types';

export function PublicRoute() {

  const isAuthenticated = useSelector(
    (state: UserState) => state.user?.accessToken
  );

  return !isAuthenticated ? <Outlet /> : <Navigate to={URLS.DASHBOARD_URL} />;
}
